import { useEffect, useState } from 'react';
import '@photo-sphere-viewer/core/index.css';
// import * as exifr from 'exifr';
import CompanyImageEquipmentMappingLayer from './CompanyImageEquipmentMappingLayer';
import CompanyPanoEquipmentMappingLayer from './CompanyPanoEquipmentMappingLayer';
import { checkImageFromBlob } from 'data/data';

export function CompanyEquipmentMappingLayer({file, fileId, mapsId, zoneId}) {
    const [imageUrl, setImageUrl] = useState(null);
    const [is360, setIs360] = useState(null);

    useEffect(()=>{
      setImageFromFile();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[]);

    const setImageFromFile = async() => {
      let fileUrl;
      if (fileId)
        fileUrl = window.RUNTIME_CONFIG.REACT_APP_API_URL+"/api/download/"+fileId;
      else if (file)
        fileUrl = file;
      else
        fileUrl = "https://photo-sphere-viewer-data.netlify.app/assets/sphere.jpg";
      // console.log(fileUrl)
      try {
        const response = await fetch(fileUrl); // 실제 API 주소로 변경
        const blob = await response.blob();
        const { url, is360 } = await checkImageFromBlob(blob);
        setImageUrl(url);
        setIs360(is360);
      } catch (error) {
        console.error('image file download fail:', error);
      }
    };

    return (
      <>
        {imageUrl && is360 === true && <CompanyPanoEquipmentMappingLayer fileUrl={imageUrl} mapsId={mapsId} zoneId={zoneId} />}
        {/* {imageUrl && is360 === false && <img src={imageUrl} alt="Thumbnail" style={{width: "80px" ,height: "80px" ,padding:"3px"}} />} */}
        {imageUrl && is360 === false && <CompanyImageEquipmentMappingLayer fileUrl={imageUrl} mapsId={mapsId} zoneId={zoneId} />}
      </>
    )
  }
  
  export default CompanyEquipmentMappingLayer;
  